/**
 * formtatea una cadena de texto y retornar solo la fecha
 * @param date string
 * @returns string
 */
export const dateFormat = (date: string) => {
    const nDate = new Date(date);

    if (nDate) {
        return new Intl.DateTimeFormat('default', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        })
            .format(nDate)
            .toString();
    }

    return '';
};
